import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { OrderFabrication } from '../models/of';
import { QueryParameter } from '../helpers/queryParameter';

const BASE_API = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class OfService {
  constructor(private http: HttpClient) { }

  /**
   * Récupère la liste des ordres de fabrication depuis l'API
   */
  getOrdersFabrication(query?: QueryParameter): Observable<OrderFabrication[]> {
    let params: HttpParams = new HttpParams();
    if (query) {
      params = params.append('query', JSON.stringify(query));
    }
    return this.http.get<OrderFabrication[]>(`${BASE_API}/OrdreFabrication/GetFull`, { params });
  }

  /**
   * Récupère un ordre de fabrication par ID
   */
  getOrderFabrication(id: number): Observable<OrderFabrication> {
    return this.http.get<OrderFabrication>(`${BASE_API}/of/${id}`);
  }

  /**
   * Crée un nouvel ordre de fabrication
   */
  createOrderFabrication(of: OrderFabrication): Observable<OrderFabrication> {
    return this.http.post<OrderFabrication>(`${BASE_API}/of`, of);
  }

  /**
   * Met à jour un ordre de fabrication
   */
  updateOrderFabrication(id: number, of: OrderFabrication): Observable<OrderFabrication> {
    return this.http.put<OrderFabrication>(`${BASE_API}/of/${id}`, of);
  }

  /**
   * Supprime un ordre de fabrication
   */
  deleteOrderFabrication(id: number): Observable<void> {
    return this.http.delete<void>(`${BASE_API}/of/${id}`);
  }
}
